import React from 'react';
import './styles/DesignerStyles.css';
import { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';

import DesignerButton from './DesignerButton';
import DesignerTextField from './DesignerTextField';

import NoGamesFoundBanner from './Images/No-Games-Found-Icon.svg';

import { checkForCode, androidBackButton } from './Utils';

import penClick from './Sounds/pen-click.wav';

class JoinRoom extends React.Component {
  static propTypes = {
    cookies: instanceOf(Cookies).isRequired,
  };

  constructor(props) {
    super(props);

    // eslint-disable-next-line
    const { cookies } = props;
    this.penClick = new Audio(penClick);

    this.state = {
      roomID: '',
      roomHasAlreadyStarted: false,
      localGamesArray: [],
    };
  }

  componentDidMount() {
    androidBackButton(this.handleGoBackRoom);
  }

  handleJoinLocalRoom = async (wifiID) => {
    let body = JSON.stringify({
      sub: this.props.cookies.get('code'),
    });

    let data = await checkForCode(
      'PUT',
      //must change to wifiID and write a API for it
      `/api/rooms/${wifiID}/joinLocal`,
      this.props,
      body
    );

    if (!data.message) {
      this.setState({ roomHasAlreadyStarted: false });
      this.penClick.play();
      this.props.navigate(`/TeamAndWords/${this.state.roomID}`);
    } else if (data.message === "started") {
      this.penClick.play();
      this.props.navigate(`/game/${this.state.roomID}`);
    } else {
      this.setState({ roomHasAlreadyStarted: true });
      console.log('the room has already started');
    }
  };

  handleJoiningRoom = async () => {
    let body = JSON.stringify({
      sub: this.props.cookies.get('code'),
    });

    let data = await checkForCode(
      'PUT',
      `/api/rooms/${this.state.roomID}/join`,
      this.props,
      body
    );

    if (!data.message) {
      this.setState({ roomHasAlreadyStarted: false });
      this.penClick.play();
      this.props.navigate(`/TeamAndWords/${this.state.roomID}`);
    } else if (data.message === "started") {
      this.penClick.play();
      this.props.navigate(`/game/${this.state.roomID}`);
    } else {
      this.setState({ roomHasAlreadyStarted: true });
      console.log('the room has already started');
    }
  };

  handleJoinWithQRCode = () => {
    console.log('log in with a QR code');
    //open the camera

    window.cordova.plugins.barcodeScanner.scan(
      (result) => {
        console.log('Result.text: ' + result.text);

        this.setState({ roomID: result.text }, () => {
          this.handleJoiningRoom();
        });
      },
      (error) => {
        alert('Scanning failed: ' + error);
      },
      {
        preferFrontCamera: false, // iOS and Android
        showFlipCameraButton: true, // iOS and Android
        showTorchButton: true, // iOS and Android
        torchOn: false, // Android, launch with the torch switched on (if available)
        saveHistory: false, // Android, save scan history (default false)
        prompt: 'Place a barcode inside the scan area', // Android
        resultDisplayDuration: 500, // Android, display scanned text for X ms. 0 suppresses it entirely, default 1500
        formats: 'QR_CODE,PDF_417', // default: all but PDF_417 and RSS_EXPANDED
        orientation: 'portrait', // Android only (portrait|landscape), default unset so it rotates with the device
        disableAnimations: true, // iOS
        disableSuccessBeep: true, // iOS and Android
      }
    );

    //take the roomID from the qr code

    //when the roomID is taken we should invoke handleJoiningRoom
  };

  handleGoBackRoom = () => {
    this.penClick.play();
    this.props.navigate(`/`);
  };

  render() {
    return (
      <div className="Home">
        <h1 className="H1Basic">Влез в игра</h1>

        <div className="arrowBackButtonDiv">
          <DesignerButton
            class="arrowBackButton"
            onClick={this.handleGoBackRoom}></DesignerButton>
        </div>

        <div className="cssBanner" style={{ display: 'none' }}>
          <hr className="cssBannerLine" />
          <div className="cssBannerText">Select Game</div>
        </div>

        {this.state.localGamesArray.length > 0 ? (
          <form
            className="localGamesFoundForm"
            action=""
            onChange={(e) => {
              let index = e.target.value;
              this.setState({ roomID: this.state.localGamesArray[index].ID });
            }}>
            {this.state.localGamesArray.map((element, index) => (
              <div
                key={index}
                className={`RadioButtonDiv ${
                  this.state.roomID === element.ID ? 'Selected' : ''
                }`}>
                <label id={element.name}>{element.name}</label>
                <input
                  type="radio"
                  id={'localGame ' + index}
                  name="drone"
                  value={index}
                />
              </div>
            ))}
          </form>
        ) : (
          <div className="noGamesFoundDiv" style={{ display: 'none' }}>
            <img src={NoGamesFoundBanner} alt=" No Games Found Banner"></img>

            <p className="noGamesFoundParagraph">No games Found!</p>
            <p className="noGamesFoundExplanationText">
              Lorem Ipsum is simply dummy text of the <br /> printing and
              typesetting industry.
            </p>
          </div>
        )}

        <div className="cssBanner">
          <hr className="cssBannerLine" />
          <div className="cssBannerText">Влез с код</div>
        </div>

        <DesignerTextField
          style={{ width: '90%' }}
          value={this.state.roomID}
          onChange={(event) => {
            this.setState({ roomID: event.target.value });
          }}
          minlength={4}
          placeholder={'Код'}></DesignerTextField>

        <div className="joinButtonOuterDiv">
          <div className="joinButtonInnerDiv">
            <DesignerButton
              class="filledButton"
              disabled={this.state.roomID.length < 8 ? true : false}
              onClick={this.handleJoiningRoom}
              buttonText="Влез"></DesignerButton>
          </div>

          <div className="QRCodeDiv">
            <DesignerButton
              class="hollowButton"
              onClick={this.handleJoinWithQRCode}
              buttonText="Сканирай QR код"></DesignerButton>
          </div>
        </div>
      </div>
    );
  }
}

export default withCookies(JoinRoom);
